import React from 'react'
import Wave from 'react-wavify'
import howWork1 from '../../Image/howWork1.png';
export const HowWork = () => {
    const howWork = ['We have a pre-defined way of working determined through various experiments to be the most effective for us, our clients, and the product we are developing.', 'We use an Agile method for all types of development, whether website design or mobile app development.', 'Every day, we inform our clients about our progress. We get a lot of work done on some days and only a little on others. However, transparency is our motto.', 'We have expertise in all the technologies we have worked on, but we are always looking for ways to grow and expand our knowledge.', 'We know that one bug causes another 20, so we’ve covered our products with automated test cases. We also understand that one thing can cause another to break. So we use GitHub or BitBucket to keep track of all the changes.', 'To understand requirements, manage tasks, and prioritize tasks, we use JIRA, Trello, Asana, and PivotTracker.']
    return (
        <div className='overflow-hidden bg-theme_light'>
          
            <Wave fill='#F0E3FF' paused={false} style={{ display: 'flex' }} options={{ height: 20, amplitude: 20, speed: 0.3, points: 5 }} className='relative min-w-[1920px] h-[28px] bg-white' />
            <div className='container  m-auto flex flex-col items-center justify-center text-justify sm:text-center py-8' >
                <img src={howWork1} data-aos="zoom-out" alt='howWork' className='w-[130px]'></img>
                <h5 className='font-bold text-2xl text-[#141414] mb-4'>HOW WE WORK </h5>
                <ul className='list-disc container'>
                    {howWork?.map((item, id) => {
                        return (
                            <li key={id}>
                                <p className='py-3 font-medium text-sm  sm:text-md 2xl:text-lg text-start text-[#000000B2]'>{item}</p>
                            </li>
                        )
                    })}

                </ul>
            </div>
        </div>
    )
}
